import { render, staticRenderFns } from "./ic-warning.vue?vue&type=template&id=558bbd14&"
import script from "./ic-warning.vue?vue&type=script&lang=js&"
export * from "./ic-warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports